import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'ngx-issue-loader',
  templateUrl: './issue-loader.component.html',
  styleUrls: ['./issue-loader.component.css'],
})
export class IssueLoaderComponent implements OnInit {

  @Input('widthInput') widthInput = false;

  constructor() { }

  ngOnInit() {
  }

}
